<template lang="pug">
	.field
		label(v-if="label" :for="id") {{ label }}
		select.input(
			:id="id"
			:name="name"
			v-model="model"
			:class="{ 'border-error': error }"
			:disabled="disabled"
		)
			option(:value="defaultValue" :disabled="defaultDisabled") {{ defaultLabel || defaultValue }}
			option(v-for="option in options" :value="option[optionValueKey]") {{ option[optionLabelKey] }}
		span.is-error(v-if="error") {{ error }}
</template>

<script>
export default {
	name: "InputSelect",
	props: {
		id: {
			type: String,
			required: false,
			default: null
		},
		name: {
			type: String,
			required: false,
			default: null
		},
		value: {
			type: [String, Number],
			required: true
		},
		label: {
			type: String,
			required: false,
			default: null
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false
		},
		options: {
			type: Array,
			required: true
		},
		optionValueKey: {
			type: [String, Number],
			required: true
		},
		optionLabelKey: {
			type: [String, Number],
			required: true
		},
		defaultLabel: {
			type: String,
			required: false,
			default: null
		},
		defaultValue: {
			type: Number,
			required: false,
			default: -1
		},
		defaultDisabled: {
			type: Boolean,
			required: false,
			default: false
		},
		error: {
			type: String,
			required: false,
			default: null
		}
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	}
};
</script>
